import axios from 'axios';

export default function postCreatePresignedUrl(bucket, key, method, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const url = config.postCreatePresignedUrl;
    const data = {
        bucket,
        key,
        method,
    };

    return dispatch => dispatch({
        type: 'CREATE_PRESIGNED_URL',
        payload: axios({ method: 'post', url, headers, data })
    });
}


// WEBPACK FOOTER //
// ./src/actions/postCreatePresignedUrl.js